<nav class="component aside-component left-nav">
  <p-menu [model]="items"></p-menu>
  <p class="quickActions">Quick Actions</p>
  <p-menu [model]="quickactions"></p-menu>
  <p-menu [model]="lowerNav"></p-menu>
</nav>
<app-goto-admin [hrAdminRoute]="hrAdminRoute" *ngIf="enableHrAdmin"></app-goto-admin>
